function unwrapLeg(legLike) {
  if (legLike == null) return null;
  return Array.isArray(legLike) ? legLike[0] : legLike;
}

/**
 * חילוץ רגלי הלוך/חזור מאובייקט linkedFlights של חבילות נופש (מקור יחיד ל־FlightDetails / כבודה).
 */
export function getDepRetLegsFromLinkedFlights(linkedFlightsData) {
  const pairs = getDepRetFlightPairs(linkedFlightsData);
  return {
    depFlight: pairs.dep?.leg ?? null,
    retFlight: pairs.ret?.leg ?? null,
  };
}

/**
 * רגלי הלוך/חזור יחד עם עטיפת flight (לשדות כבודה שמגיעים על ה-flight ולא רק על ה-leg).
 * @returns {{ dep: { leg: object|null, wrapper: object|null }|null, ret: { leg: object|null, wrapper: object|null }|null }}
 */
export function getDepRetFlightPairs(linkedFlightsData) {
  if (!linkedFlightsData) return { dep: null, ret: null };
  if (linkedFlightsData.flight) {
    const flights = Array.isArray(linkedFlightsData.flight)
      ? linkedFlightsData.flight
      : [linkedFlightsData.flight];
    const d0 = flights[0] || null;
    const d1 = flights[1] || null;
    return {
      dep: d0
        ? { wrapper: d0, leg: unwrapLeg(d0.leg) }
        : null,
      ret: d1
        ? { wrapper: d1, leg: unwrapLeg(d1.leg) }
        : null,
    };
  }
  if (Array.isArray(linkedFlightsData)) {
    const firstFlight = linkedFlightsData[0];
    if (firstFlight?.flight) {
      const flights = Array.isArray(firstFlight.flight)
        ? firstFlight.flight
        : [firstFlight.flight];
      const d0 = flights[0] || null;
      const d1 = flights[1] || null;
      return {
        dep: d0
          ? { wrapper: d0, leg: unwrapLeg(d0.leg) }
          : null,
        ret: d1
          ? { wrapper: d1, leg: unwrapLeg(d1.leg) }
          : null,
      };
    }
  }
  return { dep: null, ret: null };
}
